var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * TrendingUp component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTrendingUp extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.8942 6.55841C22.8997 6.35951 22.8266 6.15883 22.6748 6.00702C22.5714 5.90364 22.4454 5.83674 22.3126 5.80634C22.2764 5.79802 22.2391 5.79233 22.2011 5.78948C22.1822 5.78806 22.1633 5.78735 22.1443 5.78735C22.1443 5.78735 22.1442 5.78735 22.1442 5.78735H15.9011C15.4869 5.78735 15.1511 6.12314 15.1511 6.53735C15.1511 6.95157 15.4869 7.28735 15.9011 7.28735H20.3338L12.8002 14.8209C12.7947 14.826 12.7874 14.8288 12.7799 14.8288C12.7723 14.8288 12.7651 14.826 12.7595 14.8209L9.1742 11.2356L9.16884 11.2303C8.88277 10.9499 8.49815 10.7929 8.09757 10.7929C7.69699 10.7929 7.31235 10.9499 7.02627 11.2303L1.32416 16.9324C1.03127 17.2253 1.03127 17.7002 1.32416 17.9931C1.61706 18.286 2.09193 18.286 2.38482 17.9931L8.0772 12.3007C8.08277 12.2957 8.09003 12.2929 8.09757 12.2929C8.10511 12.2929 8.11237 12.2957 8.11794 12.3007L11.7033 15.8861L11.7086 15.8913C11.9947 16.1717 12.3793 16.3288 12.7799 16.3288C13.1805 16.3288 13.5651 16.1717 13.8512 15.8913L21.3942 8.34831V12.7804C21.3942 13.1946 21.73 13.5304 22.1442 13.5304C22.5584 13.5304 22.8942 13.1946 22.8942 12.7804V6.55841Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTrendingUp.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTrendingUp.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTrendingUp.prototype, "size", void 0);
if (customElements.get('cat-icon-trending-up') === undefined) {
    customElements.define('cat-icon-trending-up', BlocksIconTrendingUp);
}
